/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.Recommendations.Host.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from 'react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from 'react-query'
import type {
  ObjectQueryResult,
  PostRecommendationQueryRecommendationsParams,
  PostRecommendationSelectOptionParams,
  Query,
  Recommendation,
  RecommendationOption,
  RecommendationQueryResult
} from './Recommendations/model'
import { request } from '../Services/BasicApi';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const postRecommendationQuery = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/Recommendation/Query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Recommendations',  ...options});
    }
  


export const getPostRecommendationQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRecommendationQuery>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRecommendationQuery>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRecommendationQuery>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postRecommendationQuery(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRecommendationQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postRecommendationQuery>>>
    export type PostRecommendationQueryMutationBody = Query
    export type PostRecommendationQueryMutationError = unknown

    export const usePostRecommendationQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRecommendationQuery>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRecommendationQuery>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostRecommendationQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postRecommendationStream = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<unknown[]>(
      {url: `/Recommendation/Stream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Recommendations',  ...options});
    }
  


export const getPostRecommendationStreamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRecommendationStream>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRecommendationStream>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRecommendationStream>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postRecommendationStream(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRecommendationStreamMutationResult = NonNullable<Awaited<ReturnType<typeof postRecommendationStream>>>
    export type PostRecommendationStreamMutationBody = Query
    export type PostRecommendationStreamMutationError = unknown

    export const usePostRecommendationStream = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRecommendationStream>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRecommendationStream>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostRecommendationStreamMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postRecommendationSelectOption = (
    recommendationOption: RecommendationOption,
    params?: PostRecommendationSelectOptionParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Recommendation>(
      {url: `/Recommendation/SelectOption`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recommendationOption,
        params
    },
      { type: 'Recommendations',  ...options});
    }
  


export const getPostRecommendationSelectOptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRecommendationSelectOption>>, TError,{data: RecommendationOption;params?: PostRecommendationSelectOptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRecommendationSelectOption>>, TError,{data: RecommendationOption;params?: PostRecommendationSelectOptionParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRecommendationSelectOption>>, {data: RecommendationOption;params?: PostRecommendationSelectOptionParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postRecommendationSelectOption(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRecommendationSelectOptionMutationResult = NonNullable<Awaited<ReturnType<typeof postRecommendationSelectOption>>>
    export type PostRecommendationSelectOptionMutationBody = RecommendationOption
    export type PostRecommendationSelectOptionMutationError = unknown

    export const usePostRecommendationSelectOption = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRecommendationSelectOption>>, TError,{data: RecommendationOption;params?: PostRecommendationSelectOptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRecommendationSelectOption>>,
        TError,
        {data: RecommendationOption;params?: PostRecommendationSelectOptionParams},
        TContext
      > => {

      const mutationOptions = getPostRecommendationSelectOptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postRecommendationClearSelection = (
    postRecommendationClearSelectionBody: string[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string[]>(
      {url: `/Recommendation/ClearSelection`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRecommendationClearSelectionBody
    },
      { type: 'Recommendations',  ...options});
    }
  


export const getPostRecommendationClearSelectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRecommendationClearSelection>>, TError,{data: string[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRecommendationClearSelection>>, TError,{data: string[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRecommendationClearSelection>>, {data: string[]}> = (props) => {
          const {data} = props ?? {};

          return  postRecommendationClearSelection(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRecommendationClearSelectionMutationResult = NonNullable<Awaited<ReturnType<typeof postRecommendationClearSelection>>>
    export type PostRecommendationClearSelectionMutationBody = string[]
    export type PostRecommendationClearSelectionMutationError = unknown

    export const usePostRecommendationClearSelection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRecommendationClearSelection>>, TError,{data: string[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRecommendationClearSelection>>,
        TError,
        {data: string[]},
        TContext
      > => {

      const mutationOptions = getPostRecommendationClearSelectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postRecommendationQueryRecommendations = (
    query: Query,
    params?: PostRecommendationQueryRecommendationsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<RecommendationQueryResult>(
      {url: `/Recommendation/QueryRecommendations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Recommendations',  ...options});
    }
  


export const getPostRecommendationQueryRecommendationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRecommendationQueryRecommendations>>, TError,{data: Query;params?: PostRecommendationQueryRecommendationsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRecommendationQueryRecommendations>>, TError,{data: Query;params?: PostRecommendationQueryRecommendationsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRecommendationQueryRecommendations>>, {data: Query;params?: PostRecommendationQueryRecommendationsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postRecommendationQueryRecommendations(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRecommendationQueryRecommendationsMutationResult = NonNullable<Awaited<ReturnType<typeof postRecommendationQueryRecommendations>>>
    export type PostRecommendationQueryRecommendationsMutationBody = Query
    export type PostRecommendationQueryRecommendationsMutationError = unknown

    export const usePostRecommendationQueryRecommendations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRecommendationQueryRecommendations>>, TError,{data: Query;params?: PostRecommendationQueryRecommendationsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRecommendationQueryRecommendations>>,
        TError,
        {data: Query;params?: PostRecommendationQueryRecommendationsParams},
        TContext
      > => {

      const mutationOptions = getPostRecommendationQueryRecommendationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
